import { c as _c } from "react/compiler-runtime";
import { NewsletterSingle } from 'modules/newsletters/single';
import { NewslettersEditLoco } from 'modules/newsletters/single/constants/newsletters-loco';
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterSplitTest } from 'modules/newsletters/split-test';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Loader } from 'shared/components/loader';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const NewsletterEdit: NextPage = () => {
  const $ = _c(5);
  const router = useRouter();
  const newsletterId = Number(router.query.newsletterId) as NewsletterId;
  let t0;
  if ($[0] !== newsletterId) {
    t0 = {
      newsletterId
    };
    $[0] = newsletterId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    newsletterData
  } = useGetNewsletterView(t0);
  let t1;
  if ($[2] !== newsletterData || $[3] !== newsletterId) {
    t1 = newsletterData ? newsletterData.mailingSplitTest ? <NewsletterSplitTest newsletterWithSplitTest={newsletterData} newsletterId={newsletterId} /> : <NewsletterSingle newsletterData={newsletterData} newsletterId={newsletterId} /> : <div className="flex h-full items-center justify-center"><Loader type="dark" /></div>;
    $[2] = newsletterData;
    $[3] = newsletterId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export const getServerSideProps = getBaseServerSideProps(NewslettersEditLoco, 'header.top_menu.newsletters');
export default NewsletterEdit;